/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseDB_ApiGeneratorCaller} from "@intuitionrobotics/db-api-generator/frontend";
import {CreateOrganizationRequest, DB_Organization} from "@app/ir-q-app-common/types/care-center/organization";
import {PartialProperties} from "@intuitionrobotics/ts-common";

export class OrganizationsModule_Class
    extends BaseDB_ApiGeneratorCaller<DB_Organization> {

    constructor() {
        super({key: "organization", relativeUrl: "/v1/organization"}, "OrganizationsModule");
    }

    // Override createSync to accept both DB_Organization and CreateOrganizationRequest
    async createSync(instance: CreateOrganizationRequest | PartialProperties<DB_Organization, "_id">) {
        return super.createSync(instance as any);
    }

}

export const OrganizationsModule = new OrganizationsModule_Class();
